var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#335CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8575 36V25.0533H29.5303L30.0814 20.7859H25.8575V18.0618C25.8575 16.8266 26.199 15.9849 27.9722 15.9849L30.2301 15.984V12.1671C29.8396 12.1163 28.4993 12 26.9393 12C23.6818 12 21.4516 13.9884 21.4516 17.6391V20.7859H17.7676V25.0533H21.4516V36H25.8575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1a2b7fc306ef6891fedab148f4826e48.svg";
export { ForwardRef as ReactComponent };